import React from 'react'
import { IndexRoute, Route, Router } from 'react-router'
import { getHistory } from 'lib/history'
import * as blUrls from 'lib/urls'
import { withStaticProps } from 'lib/decorators'

import Container from './container'
import Instructions from './instructions'
import HowItWorks from './how-it-works'

class ShareExtension extends React.Component {
  constructor(props) {
    super(props)

    this.Container = withStaticProps('Container', {
      showDesktopAlert: !props.isSupportedDevice,
    })(Container)

    this.Instructions = withStaticProps('Instructions', {
      browser: props.browser,
    })(Instructions)

    this.HowItWorks = withStaticProps('HowItWorks', {
      browser: props.browser,
    })(HowItWorks)
  }

  render() {
    const history = getHistory({ path: this.props.path, useRouter: true })
    return (
      <Router history={history}>
        <Route
          path={blUrls.shareExtensionPath}
          component={this.Container}
          onChange={this.handleRouteChange.bind(this)}
        >
          <IndexRoute component={this.Instructions} />
          <Route path="how-it-works" component={this.HowItWorks} />
        </Route>
      </Router>
    )
  }

  handleRouteChange(prevState, nextState) {
    if (nextState.location.pathname != prevState.location.pathname) {
      // Scroll to the top of the page
      window.scrollTo(0, 0)
    }
  }
}

export default ShareExtension
